import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Components/HomePages/Home/Home";
import Navbar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import OurStory from "./Components/Pages/OurStory/OurStory";
import SeaFrieght from "./Components/Pages/SeaFrieght/SeaFrieght";
import AirFrieght from "./Components/Pages/AirFrieght/AirFrieght";
import DGShipping from "./Components/Pages/DGShipping/DGShipping";
import WareHousing from "./Components/Pages/WareHousing/WareHousing";
import Labelling from "./Components/Pages/Labelling/Labelling";
import CustomClearencce from "./Components/Pages/CustomClearence/CustomClearence";
import ContactUs from "./Components/ContactUs/ContactUs";
// import Incoterms from "./Components/Tools/Inco-terms/incoterms";
import ContainerSpec from "./Components/Tools/ContainerSpec/containerspec";
import Afp from "./Components/Tools/AirFreightPallets/Afp";
import Measurement from "./Components/Tools/MeasurementCalcu/Measurement";
import Seaport from "./Components/Tools/Worldseaport/Seaport";
import Airport from "./Components/Tools/Worldairport/Airport";

import WhatsAppChat, {
  MessageChat,
} from "./Components/HomePages/WhatsAppShow/WhatsApp";
function App() {
  return (
    <>
      <Router>
        <Navbar />
        <WhatsAppChat />
        <MessageChat />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/OurStory" element={<OurStory />} />
          <Route exact path="/Sea-Frieght" element={<SeaFrieght />} />
          <Route exact path="/Air-Frieght" element={<AirFrieght />} />
          <Route exact path="/DG-Shipping" element={<DGShipping />} />
          <Route exact path="/WareHousing" element={<WareHousing />} />
          <Route exact path="/Labelling" element={<Labelling />} />
          <Route exact path="/ContactUs" element={<ContactUs />} />
          {/* <Route exact path="/incoterms" element={<Incoterms />} /> */}
          <Route exact path="/ContainerSpec" element={<ContainerSpec />} />
          <Route exact path="/Afp" element={<Afp />} />
          <Route exact path="/Measurement" element={<Measurement />} />
          <Route exact path="/Seaport" element={<Seaport />} />
          <Route exact path="/Airport" element={<Airport />} />
          <Route
            exact
            path="/Customs-Clearence"
            element={<CustomClearencce />}
          />
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
